import { useMemo } from 'react';
import { useAuth } from '../context/AuthContext';
import { hasPlatformPermission, hasAnyPlatformPermission } from '../auth/permissions';

export function usePlatformPermissions() {
  const { platformPermissions, hasPlatformPermission: check, hasPlatformAccess } = useAuth();
  const permissions = useMemo(() => platformPermissions || [], [platformPermissions]);

  return {
    permissions,
    hasPlatformAccess,
    hasPlatformPermission: (permission) =>
      check(permission) || hasPlatformPermission(permissions, permission),
    hasAnyPlatformPermission: (needed) => hasAnyPlatformPermission(permissions, needed),
  };
}

export default usePlatformPermissions;
